module.exports = __webpack_public_path__ + "img/marker_search.4af30e4f.png";